/** Reorder a copied array after a CDK drag-drop event. */
export function reorderDragDropRows<T>(
	rows: T[],
	previousIndex: number,
	currentIndex: number
): T[] {
	const next = [...rows];
	const [moved] = next.splice(previousIndex, 1);
	next.splice(currentIndex, 0, moved);
	return next;
}

/** Resolve a schema field display title with a caller-specific fallback. */
export function schemaFieldDisplayTitle<T extends { name: string }>(
	name: string,
	availableFields: T[],
	displayLabel: (field: T) => string,
	fallback: (trimmed: string) => string
): string {
	const trimmed = name?.trim() ?? '';
	if (!trimmed) {
		return '';
	}
	const fromSchema = availableFields.find(field => field.name === trimmed);
	if (fromSchema) {
		return displayLabel(fromSchema);
	}
	return fallback(trimmed);
}

/** Saved dimension/metric row from card `data` (editor state). */
export interface SavedChartDataField {
	name?: string;
	id?: string;
	label?: string;
	dataType?: string;
}

export function findDimensionByName(
	dimensions: SavedChartDataField[] | undefined,
	name: string
): SavedChartDataField | undefined {
	const trimmed = name?.trim() ?? '';
	if (!trimmed || !Array.isArray(dimensions)) {
		return undefined;
	}
	return dimensions.find(dimension => dimension.name === trimmed);
}

export function findMetricByName(
	metrics: SavedChartDataField[] | undefined,
	name: string
): SavedChartDataField | undefined {
	return findDimensionByName(metrics, name);
}
